import groupMap from './groupByMap';
import orderMap from './orderByMap';

export const stringifyQS = (arr, name) => {
    const query = new URLSearchParams();
    arr.forEach(o => {
        const t = name === 'groupBy' ? groupMap : orderMap;
        const fakeName = t.toFake[o];
        if (fakeName) query.append(name, fakeName);
    });
    return query.toString();
};

export const getSettings = (user, client, initialColumns) => {
    /*
        Careful on modifying insightColumns, test extensively.
        Store settings before update, test after update.
        Change keys on the stored object in Local Storage.
    */
    const settings = JSON.parse(
        localStorage.getItem(
            `mvc-insights-columns--${user.id}-${client.id}-v3`,
        ),
    );
    if (!settings) return initialColumns;

    let valid = true;

    // check for invalid keys in settings object
    for (const col in settings) {
        if (
            Object.prototype.hasOwnProperty.call(settings, col) &&
            !Object.prototype.hasOwnProperty.call(initialColumns, col)
        ) {
            valid = false;
        }
    }

    // check that the settings object has all columns set up
    for (const col in initialColumns) {
        if (
            Object.prototype.hasOwnProperty.call(initialColumns, col) &&
            !Object.prototype.hasOwnProperty.call(settings, col)
        ) {
            valid = false;
        }
    }

    // stored settings are invalid, replace them with the default
    if (!valid) {
        localStorage.setItem(
            `mvc-insights-columns--${user.id}-${client.id}-v3`,
            JSON.stringify(initialColumns),
        );
        return initialColumns;
    }
    return settings;
};
